import React, { Component } from 'react';
import api from '../../services/api';
import '../FormatNumero/FormatCurrency';
import currencyFormatter from '../FormatNumero/FormatCurrency';
import Menu from '../menu/Menu';
import './ListaItemPedido.css'
import Cookies from 'universal-cookie';

export default class ItemPedido extends Component {

    state = {
        _ItemPedido: [],
        ckCPF: '',
    }

    async componentDidMount() {
        const cookies = new Cookies();
        this.state.ckCPF = cookies.get('ckCPF')
        console.log(this.state.ckCPF)
        const { NumPed } = this.props.match.params;
        const response = await api.get(`/datasnap/rest/tsm/RecItem_Pedidos("${this.state.ckCPF}",${NumPed}`);
        this.setState({ _ItemPedido: response.data.result[0] });
    }
    render() {
        return (
            <div className="principal">
                <div className="ListaItemPed">
                    <Menu />
                    <p></p>
                    <div>
                        <div className="sleft"><a href="/HOn/ListaPedido" className="btn btn-secondary btn-sm active " role="button" aria-pressed="true">Voltar</a></div>
                        
                        <h2>Lista de Itens do Pedidos</h2>
                    </div>
                    <table className="table table-hover table-striped table-dark">
                        <thead>
                            <tr>
                                {/* NUMPED":"2700080040","CODPROD":"11515","DESCRICAO":"DANONINHO PET SUIS MORANGO 24X240G","QT":"3","PVENDA":"3"} */}
                                <th scope="col">Cód.</th>
                                <th scope="col">Descrição</th>
                                <th scope="col">Qtd.</th>
                                <th scope="col">P. Venda R$</th>
                                <th scope="col">Total R$</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state._ItemPedido.map(ItemPedido => (
                                <tr key={ItemPedido.NUMPED}>
                                    <td>{ItemPedido.CODPROD}</td>
                                    <td>{ItemPedido.DESCRICAO}</td>
                                    <td>{ItemPedido.QT}</td>
                                    <td>{currencyFormatter(parseFloat(ItemPedido.PVENDA.toString().replace(",", ".")))}</td>
                                    <td>{currencyFormatter(parseFloat(ItemPedido.QT) * parseFloat(ItemPedido.PVENDA.toString().replace(",", ".")))}</td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                    {/* <h4><Link to='/ListaPedido'>Voltar</Link></h4> */}
                </div>
            </div>
        )
    }
}